import { AppId, DevelopEnvironment, Environment, XPlatform } from '@foxeet/domain';
import { VERSION } from './version';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: Environment = {
  app: AppId.IVFORCE,
  appName: 'Inteligencia Versátil',
  wikiURL: '/assets/demo-blank.pdf',
  platform: XPlatform.WEB_ADMIN,
  production: false,
  version: VERSION,

  envName: DevelopEnvironment.dev,
  defaultEndpoint: 'https://dev-3-api.iv.solutions',
  devEndpoint: 'https://dev-3-api.iv.solutions',
  qaEndpoint: 'https://qa-migration.iv.solutions',
  prodEndpoint: 'https://api.iv.solutions',

  mapbox: {
    accessToken: 'pk.eyJ1IjoiaW5zdGl0dXRvIiwiYSI6ImNrN2xwd3hxdDAyYTkzZXAzdXJvaDd5aTQifQ.ep-LJ8wr0Jm3_nWlWf7NUw',
  },
  googleMapsApiKey: 'AIzaSyBPvVFZ8zWT8uOiYlPUb3zcgGD0oods9dc',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
